// eslint-disable-next-line
import { MEDIA_FILE_FILTERS, MEDIA_FILES_ORDER, MEDIA_FILES_SORT } from 'enums'
import { isEmpty } from 'lodash'
import { Folder } from '~/models/Folder'
import { isVoiceover } from '~/Util/recording'
// eslint-disable-next-line
import * as Assets from '~/models/Asset'

/**
 * @typedef {typeof MEDIA_FILE_FILTERS[keyof typeof MEDIA_FILE_FILTERS]} MediaFilesFilter
 * @typedef {typeof MEDIA_FILES_ORDER[keyof typeof MEDIA_FILES_ORDER]} MediaFilesOrder
 * @typedef {typeof MEDIA_FILES_SORT[keyof MEDIA_FILES_SORT]} MediaFilesSort

 *
 * @typedef {object} SourceFilesFilterParams
 * @property {MediaFilesOrder} order
 * @property {MediaFilesSort} sort
 * @property {MediaFilesFilter} filter
 * @property {string} search
 *
 * @typedef {object} PrevFilterParams
 * @property {SourceFilesFilterParams} current
 *
 * @param {Assets.MediaAsset[]} sourceFiles
 * @param {SourceFilesFilterParams} filterParams
 * @param {PrevFilterParams} prevParams
 * @returns {Assets.MediaAsset[]}
 */

export const filterAssetsByParams = (sourceFiles, filterParams, prevParams) => {
  if (!sourceFiles || isEmpty(sourceFiles)) {
    return []
  }

  let result = [ ...sourceFiles ]
  const { order, sort, filter, search } = filterParams
  if (search) {
    result = result.filter(item => item.name.includes(search))
  }

  result = result.sort((a, b) => {
    switch (sort) {
      case MEDIA_FILES_SORT.Duration:
        if (order === MEDIA_FILES_ORDER.Ascending) {
          return a.duration - b.duration
        }
        return b.duration - a.duration
      case MEDIA_FILES_SORT.Size:
        if (order === MEDIA_FILES_ORDER.Ascending) {
          return a.size - b.size
        }
        return b.size - a.size
      case MEDIA_FILES_SORT.Date:
        if (order === MEDIA_FILES_ORDER.Ascending) {
          return a.createTime - b.createTime
        }
        return b.createTime - a.createTime
      case MEDIA_FILES_SORT.Name:
        if (order === MEDIA_FILES_ORDER.Ascending) {
          return a.name.localeCompare(b.name)
        }
        return b.name.localeCompare(a.name)
      default:
        return 0
    }
  })

  switch (filter) {
    case MEDIA_FILE_FILTERS.Voiceover:
      result = result.filter(asset => (asset.constructor === Assets.AudioAsset)
        && isVoiceover(asset))
      break
    case MEDIA_FILE_FILTERS.Audio:
      result = result.filter(asset => asset.constructor === Assets.AudioAsset)
      break
    case MEDIA_FILE_FILTERS.Video:
      result = result.filter(asset => asset.constructor === Assets.VideoAsset)
      break
    case MEDIA_FILE_FILTERS.Image:
      result = result.filter(asset => asset.constructor === Assets.ImageAsset)
      break
    case MEDIA_FILE_FILTERS.Folder:
      result = result.filter(asset => asset.constructor === Folder)
      break
    default:
      break
  }
  if (prevParams) {
    // eslint-disable-next-line no-param-reassign
    prevParams.current = filterParams
  }
  return result
}
